import React from 'react';
import { addBase64Header } from '../../../utils/StringUtil';

const INFORMATION_DOCUMENT_THUMBNAIL_NUMBER = 5;

export interface ThumbnailCardProps {
  fileName: string;
  dataObject: string;
  index: number;
  numberOfthumbnails: number;
  showAll?: boolean;
}

const ThumbnailCard: React.FC<ThumbnailCardProps> = ({ fileName, dataObject, index, numberOfthumbnails, showAll }) => {
  return (
    <>
      <div
        className={`panel-added-image u-w-full ${showAll ? '' : index <= INFORMATION_DOCUMENT_THUMBNAIL_NUMBER ? '' : 'u-hidden'}`}
        tabIndex={0}>
        <div className='panel-added-image__image-area' style={{ backgroundImage: 'url(' + addBase64Header(dataObject) + ')' }}>
          <p className='panel-added-image__tag'>
            {index}/{numberOfthumbnails}
          </p>
        </div>
        <p className='panel-added-image__name'>{fileName}</p>
      </div>
    </>
  );
};

export default ThumbnailCard;
